import type { Plan } from '../types/content'

export const planes: Plan[] = [
  {
    id: 'megapack',
    emoji: '📘',
    name: 'Mega Pack Cocina Lista',
    includes: '6 Tomos + 6 Bonos',
    bestFor: 'Tu semana resuelta de una vez',
    listPrice: '$58.000 ARS',
    price: '$19.990 ARS',
    features: [
      '6 Tomos completos (200+ páginas)',
      '6 Bonos estratégicos gratis',
      'Checklists imprimibles',
      'Listas de compras semanales',
      'Acceso inmediato en PDF',
      'Sistema para toda Argentina',
    ],
    cta: 'Quiero mi Mega Pack',
    checkoutUrl:
      'https://www.recursoclosethegap.shop/cart/51761212227879:1',
    featured: false,
  },
  {
    id: 'sistema-total',
    emoji: '🏆',
    name: 'Mega Pack + Sistema Total',
    includes: '6 Tomos + 6 Bonos + Manual Sistema Total de Salud',
    bestFor: 'Las que quieren el sistema completo',
    listPrice: '$78.000 ARS',
    price: '$27.990 ARS',
    features: [
      'Todo lo del Mega Pack base',
      'Manual Sistema Total de Salud',
      'Protocolo de hábitos 30 días',
      'Guía de suplementación básica',
      'Plan de hidratación semanal',
      'Acceso prioritario a actualizaciones',
    ],
    cta: 'Quiero el Sistema Total',
    checkoutUrl:
      'https://www.recursoclosethegap.shop/cart/51761223106855:1',
    featured: true,
  },
]
